import { render, staticRenderFns } from "./logisticsSettlement.vue?vue&type=template&id=2c3e9a6b&scoped=true&"
import script from "./logisticsSettlement.vue?vue&type=script&lang=js&"
export * from "./logisticsSettlement.vue?vue&type=script&lang=js&"
import style0 from "./logisticsSettlement.vue?vue&type=style&index=0&id=2c3e9a6b&lang=less&scoped=true&"
import style1 from "./logisticsSettlement.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e9a6b",
  null
  
)

component.options.__file = "logisticsSettlement.vue"
export default component.exports